import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchActionPlan, updateActionPlan } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

const ACTION_PLAN_TYPES = ["Plan", "Do", "CheckAct", "None"];

export default function ActionPlanEditPage() {
  const { businessDomainId, businessUnitId, actionPlanId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [original, setOriginal] = useState(null);
  const [form, setForm] = useState({
    actionPlanId: "",
    companyId: "",
    actionPlanName: "",
    actionPlanDescription: "",
    actionPlanType: "None",
    businessProcessId: "",
    businessProcessName: "",
    businessUnitId: "",
    businessUnitName: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchActionPlan(actionPlanId);
        setOriginal(d);
        setForm({
          actionPlanId:          d.actionPlanId          || "",
          companyId:             d.companyId             || "",
          actionPlanName:        d.actionPlanName        || "",
          actionPlanDescription: d.actionPlanDescription || "",
          actionPlanType:        d.actionPlanType        || "None",
          businessProcessId:     d.businessProcessId     || "",
          businessProcessName:   d.businessProcessName   || "",
          businessUnitId:        d.businessUnitId        || "",
          businessUnitName:      d.businessUnitName      || "",
        });
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionPlanId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateActionPlan({ ...original, ...form });
      notify.success(t("message.update.success"));
      navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/action-plans/${actionPlanId}`, { replace: true });
    } catch (err) { notify.apiError(err); }
  };

  if (!original) return null;

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("actionPlan.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          {/* アクションプラン名 */}
          <Grid size={12}>
            <TextField
              fullWidth required
              label={t("actionPlan.name")}
              name="actionPlanName"
              value={form.actionPlanName}
              onChange={handleChange}
            />
          </Grid>

          {/* 説明 */}
          <Grid size={12}>
            <TextField
              fullWidth multiline rows={3}
              label={t("common.description")}
              name="actionPlanDescription"
              value={form.actionPlanDescription}
              onChange={handleChange}
            />
          </Grid>

          {/* アクションプランタイプ */}
          <Grid size={12}>
            <FormControl fullWidth>
              <InputLabel>{t("actionPlan.type")}</InputLabel>
              <Select
                value={form.actionPlanType}
                name="actionPlanType"
                onChange={handleChange}
                label={t("actionPlan.type")}
              >
                {ACTION_PLAN_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>{t(`actionPlanType.${type}`)}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* ビジネスプロセス（変更不可） */}
          <Grid size={12}>
            <FormControl fullWidth disabled>
              <InputLabel>{t("actionPlan.businessProcess")}</InputLabel>
              <Select
                value={form.businessProcessId}
                label={t("actionPlan.businessProcess")}
              >
                <MenuItem value={form.businessProcessId}>
                  {form.businessProcessName}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* 事業単位（変更不可） */}
          <Grid size={12}>
            <FormControl fullWidth disabled>
              <InputLabel>{t("actionPlan.businessUnit")}</InputLabel>
              <Select
                value={form.businessUnitId}
                label={t("actionPlan.businessUnit")}
              >
                <MenuItem value={form.businessUnitId}>
                  {form.businessUnitName}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/action-plans/${actionPlanId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
